const binding = { modules: {}, dataActions: {} };

    (binding.modules['vinhuset-fullscreen-content-block'] = {
        c: () => require('partner/modules/vinhuset-fullscreen-content-block/vinhuset-fullscreen-content-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'vinhuset-fullscreen-content-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/vinhuset-fullscreen-content-block'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|vinhuset-fullscreen-content-block|vinhuset-fullscreen-content-block'] = {
                c: () => require('partner/modules/vinhuset-fullscreen-content-block/vinhuset-fullscreen-content-block.view.tsx'),
                cn: '__local__-__local__-vinhuset-fullscreen-content-block'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };